<div class="user-menu-container" [matMenuTriggerFor]="userMenu">
    <img class="logo" [src]="userLogoOrDefaultLogo$ | async" alt="User logo" (error)="errorHandler($event)" />

    <span class="user-name-header">
        Account
    </span>
</div>
<mat-menu #userMenu="matMenu" class="user-menu-button-list">
    <button mat-menu-item (click)="logout()">Logout</button>
</mat-menu>
